var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6H9C10.1046 6 11 6.89543 11 8V18.5585L10.5562 18.4105C9.74042 18.1386 8.88619 18 8.02633 18H5C4.44772 18 4 17.5523 4 17V7C4 6.44772 4.44772 6 5 6ZM12.3162 20.8946C12.111 20.963 11.889 20.963 11.6838 20.8946L9.9237 20.3079C9.3119 20.104 8.67123 20 8.02633 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H9C10.1947 4 11.2671 4.52376 12 5.35418C12.7329 4.52376 13.8053 4 15 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H15.9737C15.3288 20 14.6881 20.104 14.0763 20.3079L12.3162 20.8946ZM15 6H19C19.5523 6 20 6.44772 20 7V17C20 17.5523 19.5523 18 19 18H15.9737C15.1138 18 14.2596 18.1386 13.4438 18.4105L13 18.5585V8C13 6.89543 13.8954 6 15 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.169192a166830dea2459040229233fd4.svg";
export { ForwardRef as ReactComponent };